/**
* 上下游管理 应用管理
*/
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>上下游管理</el-breadcrumb-item>
            <el-breadcrumb-item>应用管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="应用">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.app_name"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,1)"  @change="handleChange1" placeholder="应用">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="运营人员">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.operationsman_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,2)"  @change="handleChange2" placeholder="运营人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="销售人员">
                <el-autocomplete size="small" popper-class="my-autocomplete" v-model="formInline.salesman_name"
                    :fetch-suggestions="paramValueSearch3" @select="handleSelect($event,3)"  @change="handleChange3" placeholder="销售人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
            </el-form-item>
            <el-form-item label="客户公司">
                <el-input size="small" v-model="formInline.customer_company" placeholder="输入客户公司"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search" v-auth="'appinfo.list'">搜索
                </el-button>
                <el-button size="small" type="default" icon="el-icon-refresh" @click="reset">重置</el-button>
                <el-button size="small" type="primary" icon="el-icon-circle-plus" @click="handleEdit()"
                    v-auth="'appinfo.addorupdate'">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <div class="el-table-con">
            <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;" @sort-change="sortChange">
                <el-table-column align="center" type="selection" width="60">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_id" label="应用ID" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="app_name" label="应用名称" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="operationsman_name" label="运营人员"
                    max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="salesman_name" label="销售人员" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="customer_company" label="客户公司" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="remark" label="备注" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="update_time" label="修改时间" max-width="120">
                </el-table-column>
                <el-table-column align="center" sortable="custom" prop="add_time" label="添加时间" max-width="120">
                </el-table-column>
                <el-table-column align="center" label="操作" width="300">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)" v-auth="'appinfo.addorupdate'">编辑
                        </el-button>
                        <el-button size="mini" type="primary" @click="handleDispose(scope.row)">接口配置
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog()'>
            <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
                <el-form-item label="应用ID" prop="app_id" v-if="editForm.app_id">
                    <el-input size="small" v-model="editForm.app_id" auto-complete="off" disabled></el-input>
                </el-form-item>
                <el-form-item label="应用名称" prop="app_name">
                    <el-autocomplete size="small" popper-class="my-autocomplete" v-model="editForm.app_name"
                    :fetch-suggestions="paramValueSearch1" @select="handleSelect($event,4)" placeholder="应用">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
                </el-form-item>
                <el-form-item label="苹果链接" prop="appstore_url">
                    <el-input size="small" v-model="editForm.appstore_url" auto-complete="off" placeholder="请输入苹果链接">
                    </el-input>
                </el-form-item>
                <el-form-item label="运营人员" prop="operationsman_id">
                    <el-autocomplete size="small" popper-class="my-autocomplete" v-model="editForm.operationsman_name"
                    :fetch-suggestions="paramValueSearch2" @select="handleSelect($event,5)" placeholder="运营人员">
                    <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                    <template slot-scope="{ item }">
                        <div class="name">{{ item.value }}</div>
                    </template>
                </el-autocomplete>
                </el-form-item>
                <el-form-item label="销售人员" prop="salesman_id">
                    <el-autocomplete size="small" popper-class="my-autocomplete" v-model="editForm.salesman_name"
                        :fetch-suggestions="paramValueSearch3" @select="handleSelect($event,6)" placeholder="销售人员">
                        <i class="el-icon-edit el-input__icon" slot="suffix"></i>
                        <template slot-scope="{ item }">
                            <div class="name">{{ item.value }}</div>
                        </template>
                    </el-autocomplete>
                </el-form-item>
                <el-form-item label="客户公司" prop="customer_company">
                    <el-input size="small" v-model="editForm.customer_company" auto-complete="off"
                        placeholder="请输入客户公司">
                    </el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input size="small" v-model="editForm.remark" auto-complete="off" placeholder="请输入备注">
                    </el-input>
                </el-form-item>
                <el-form-item label="CPL任务期数" prop="selfdistinct_scope">
                    <el-input size="small" v-model="editForm.selfdistinct_scope" auto-complete="off" placeholder="仅CPL任务该值必填，例如c1代表一期">
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" class="title" @click="submitForm('editForm')">
                    保存
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    let change = [];
    import {
        appList,
        appListTotal,
        appInfo,
        appSave
    } from '../../api/basisMG'
    import { userList } from '../../api/userMG'
    import Pagination from '../../components/Pagination'
    export default {
        inject: ['reload'],
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                title: '添加应用',
                isShowroleId: 'false',
                editForm: {
                    app_id: '',
                    app_name: '',
                    appstore_url: '',
                    operationsman_id: '',
                    operationsman_name: '',
                    salesman_id: '',
                    salesman_name: '',
                    customer_company: '',
                    remark: '',
                    selfdistinct_scope: '',
                },
                // rules 表单验证
                rules: {
                    app_name: [
                        { required: true, message: '请输入应用', trigger: ['blur','change'] }
                    ],
                    appstore_url: [
                        { required: true, message: '请输入苹果链接', trigger: 'blur' }
                    ],
                    operationsman_id: [
                        { required: true, message: '请选择运营人员', trigger: ['blur','change'] }
                    ],
                    salesman_id: [
                        { required: true, message: '请选择销售人员', trigger: ['blur','change'] }
                    ],
                },
                formInline: {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    app_name: '',
                    operationsman_id: '',
                    operationsman_name: '',
                    salesman_id: '',
                    salesman_name: '',
                    customer_company: '',
                    orderby: ''
                },
                listData: [], //应用数据
                // 分页参数
                pageparm: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 10
                },
                operationsmanlist: [], //运营人员列表
                salesmanlist: [], //营销人员列表
                platParamValueList: []
            }
        },
        // 注册组件
        components: {
            Pagination
        },
        /**
         * 数据发生改变
         */

        watch: {},

        /**
         * 创建完毕
         */

        created() { },
        mounted() {
            this.reset()
            this.getoperationsmanlist()
            this.getsalesmanlist()
        },
        /**
         * 里面的方法只有被调用才会执行
         */

        methods: {
            // 获取应用列表
            getdata(parameter) {
                var that = this;
                that.loading = true;
                appList(parameter)
                    .then(res => {
                        that.loading = false
                        if (res.statusCode == 200) {
                            that.listData = res.data.datas
                            // 分页赋值
                            that.pageparm.currentPage = res.data.pageindex
                            that.pageparm.pageSize = res.data.pagesize
                            that.pageparm.total = res.data.rowscount
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取运营人员列表
            getoperationsmanlist() {
                var that = this;
                var data = {
                    'pagesize': '0',
                    'role_name': '运营'
                }
                this.operationsmanlist = []
                userList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.operationsmanlist.push({
                                    value: item.user_name,
                                    id: item.user_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取销售人员列表
            getsalesmanlist() {
                var that = this;
                var data = {
                    'pagesize': '0',
                    'role_name': '销售'
                }
                this.salesmanlist = []
                userList(data)
                    .then(res => {
                        if (res.statusCode == 200) {
                            res.data.datas.forEach(item => {
                                that.salesmanlist.push({
                                    value: item.user_name,
                                    id: item.user_id
                                })
                            });
                        } else {
                            that.$message.error(res.message)
                        }
                    })
            },
            // 获取应用信息
            getappInfo(id) {
                var that = this;
                appInfo({ app_id: id }).then(res => {
                    if (res.statusCode == 200) {
                        that.operationsmanlist.forEach(item => {
                            if(item.id == res.data.operationsman_id){
                                res.data.operationsman_name = item.value
                            }
                        });
                        that.salesmanlist.forEach(item => {
                            if(item.id == res.data.salesman_id){
                                res.data.salesman_name = item.value
                            }
                        });
                        that.editForm = res.data;
                    } else {
                        that.$message.error(res.message)
                    }
                })
            },
            // 分页插件事件
            callFather(parm) {
                this.formInline.pageindex = parm.currentPage
                this.formInline.pagesize = parm.pageSize
                localStorage.setItem('advert', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 排序
            sortChange(column, prop, order) {
                var order = '';
                if (column.order == 'ascending') {
                    order = 'asc'
                } else if (column.order == 'descending') {
                    order = 'desc'
                }
                if (order) {
                    this.formInline.orderby = column.prop + ' ' + order
                    this.search();
                }
            },
            // 搜索事件
            search() {
                this.formInline.pageindex = 1;
                localStorage.setItem('advert', JSON.stringify(this.formInline))
                this.getdata(this.formInline)
            },
            // 重置
            reset() {
                this.formInline = {
                    pageindex: 1,
                    pagesize: 20,
                    app_id: '',
                    operationsman_id: '',
                    salesman_id: '',
                    customer_company: '',
                    orderby: ''
                }
                // 重置清掉本地搜索缓存
                localStorage.removeItem('advert')
                this.platParamValueList = appListTotal()
                this.getdata(this.formInline)
            },
            //显示编辑界面
            handleEdit: function (row) {
                this.editFormVisible = true
                if (row != undefined && row != 'undefined') {
                    this.title = '修改应用'
                    this.getappInfo(row.app_id);
                } else {
                    this.title = '添加应用'
                    this.editForm = {
                        app_id: '',
                        app_name: '',
                        appstore_url: '',
                        operationsman_id: '',
                        operationsman_name: '',
                        salesman_id: '',
                        salesman_name: '',
                        customer_company: '',
                        remark: '',
                        selfdistinct_scope: '',
                    }
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                var that = this;
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        var editForm = that.editForm
                        // 添加没有app_id
                        if (!editForm.app_id) {
                            delete editForm.app_id
                        }
                        delete editForm.operationsman_name;
                        delete editForm.salesman_name
                        appSave(editForm)
                            .then(res => {
                                that.editFormVisible = false
                                if (res.statusCode == 200) {
                                    // 添加应用时清空搜索条件
                                    if (that.title == '添加应用') {
                                        that.reset();
                                    } else {
                                        that.getdata(that.formInline)
                                    }
                                    that.$message({
                                        type: 'success',
                                        message: that.title + '成功！'
                                    })
                                } else {
                                    that.$message.error(res.message)
                                }
                            })
                    } else {
                        return false
                    }
                })
            },
            // 关闭编辑、增加弹出框
            closeDialog() {
                this.editFormVisible = false
            },
            // 接口配置
            handleDispose(row) {
                this.$router.push({ path: '/control/dispose', query: { app_id: row.app_id } })
            },
            // 自定义输入下拉框
            paramValueSearch1(queryString, cb) {
                var platParamValueList = this.platParamValueList;
                var results = queryString ? platParamValueList.filter(this.createFilter(queryString)) : platParamValueList;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch2(queryString, cb) {
                var operationsmanlist = this.operationsmanlist;
                var results = queryString ? operationsmanlist.filter(this.createFilter(queryString)) : operationsmanlist;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            paramValueSearch3(queryString, cb) {
                var salesmanlist = this.salesmanlist;
                var results = queryString ? salesmanlist.filter(this.createFilter(queryString)) : salesmanlist;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (restaurant) => {
                    return restaurant.value.toUpperCase().match(queryString.toUpperCase()) //模糊查询
                    // return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0); // 精准查询
                };
            },
            handleSelect(item,index){
                if(index == 1){
                    this.formInline.app_id = item.id;
                    this.formInline.app_name = item.value;
                }else if(index == 2){
                    this.formInline.operationsman_id = item.id;
                    this.formInline.operationsman_name = item.value;
                }else if(index == 3){
                    this.formInline.salesman_id = item.id;
                    this.formInline.salesman_name = item.value;
                }else if(index == 4){
                    this.editForm.app_id = item.id;
                    this.editForm.app_name = item.value;
                }else if(index == 5){
                    this.editForm.operationsman_id = item.id;
                    this.editForm.operationsman_name = item.value;
                }else if(index == 6){
                    this.editForm.salesman_id = item.id;
                    this.editForm.salesman_name = item.value;
                }
            },
            handleChange1(val){
                if(val == ''){
                    this.formInline.app_id = '';
                    this.formInline.app_name = '';
                    localStorage.setItem('advert', JSON.stringify(this.formInline))
                }
            },
            handleChange2(val){
                if(val == ''){
                    this.formInline.operationsman_id = '';
                    this.formInline.operationsman_name = '';
                    localStorage.setItem('advert', JSON.stringify(this.formInline))
                }
            },
            handleChange3(val){
                if(val == ''){
                    this.formInline.salesman_id = '';
                    this.formInline.salesman_name = '';
                    localStorage.setItem('advert', JSON.stringify(this.formInline))
                }
            },
        }
    }
</script>

<style scoped>
    .user-search {
        margin-top: 20px;
    }

    .userRole {
        width: 100%;
    }
</style>
<style>
    .el-table-con {
        height: calc(100vh - 380px) !important;
    }

    .page-box {
        text-align: right !important;
    }

    /* 固定el-table头部 */
    .el-table {
        max-height: calc(100vh - 380px) !important;
    }

    .el-table__body-wrapper.is-scrolling-none {
        overflow-y: auto !important;
        max-height: calc(100vh - 465px) !important;
    }

    .el-dialog__body {
        max-height: 55vh;
        overflow-y: scroll;
    }

    .el-dialog__body::-webkit-scrollbar {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/views/control/advertlist.vue